import {
  API_HELP_SUCCESS,
  API_HELP_FAILURE,
  API_HELP_LOADING,
  API_SEATTYPES_SUCCESS,
  API_SEATTYPES_FAILURE,
  API_SEATTYPES_LOADING,
  API_CHILDAGES_SUCCESS,
  API_CHILDAGES_LOADING,
  API_CHILDAGES_FAILURE,
  API_PAYMENTCARDTYPES_SUCCESS,
  API_PAYMENTCARDTYPES_FAILURE,
  API_PAYMENTCARDTYPES_LOADING,
  API_PAYMENTCOUNTRIES_SUCCESS,
  API_PAYMENTCOUNTRIES_FAILURE,
  API_PAYMENTCOUNTRIES_LOADING
} from '../actions/constants';

const initialState = {
  isLoading: false,
  hasFailed: false,
  data: { help: {}, seatTypes: [], childAges: [], paymentCardTypes: [], paymentCountries: [] }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case API_HELP_LOADING:
      return { ...state, isLoading: action.isLoading };
    case API_HELP_SUCCESS:
      return { ...state, data: { ...state.data, help: action.data } };
    case API_HELP_FAILURE:
      return { ...state, hasFailed: action.hasFailed };
    case API_SEATTYPES_LOADING:
      return { ...state, isLoading: action.isLoading };
    case API_SEATTYPES_SUCCESS:
      return { ...state, data: { ...state.data, seatTypes: action.data } };
    case API_SEATTYPES_FAILURE:
      return { ...state, hasFailed: action.hasFailed };
    case API_CHILDAGES_LOADING:
      return { ...state, isLoading: action.isLoading };
    case API_CHILDAGES_SUCCESS:
      return { ...state, data: { ...state.data, childAges: action.data } };
    case API_CHILDAGES_FAILURE:
      return { ...state, hasFailed: action.hasFailed };
    case API_PAYMENTCARDTYPES_LOADING:
      return { ...state, isLoading: action.isLoading };
    case API_PAYMENTCARDTYPES_SUCCESS:
      return { ...state, data: { ...state.data, paymentCardTypes: action.data } };
    case API_PAYMENTCARDTYPES_FAILURE:
      return { ...state, hasFailed: action.hasFailed };
    case API_PAYMENTCOUNTRIES_LOADING:
      return { ...state, isLoading: action.isLoading };
    case API_PAYMENTCOUNTRIES_SUCCESS:
      return { ...state, data: { ...state.data, paymentCountries: action.data } };
    case API_PAYMENTCOUNTRIES_FAILURE:
      return { ...state, hasFailed: action.hasFailed };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/info_reducer.js